import { queryStringify } from '@utils'
import { createMutationHelper } from '@utils/swr'
import { type DeleteAccountRequest } from '../../../types/apiRequest'
import { type DeleteAccountResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const { useMutation } = createMutationHelper<CosignApis['delete']['wordpressUser'], DeleteAccountResponse, DeleteAccountRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/wordpress-user',
  fetcher: (url, { client, arg }) => {
    return client.delete(`${url}?${queryStringify(arg)}`)
  },
})

export const useRequestDeleteWordPressUser = useMutation
